import React from "react";
import Loaders from '../Loaders';
import BlockUi from '@availity/block-ui';
import * as tmscall from "../common/restService/tmServices";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
//import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import {
  Grid,
  GridColumn,
  GridToolbar as Column,
  GridDetailRow,
  GridToolbar,
} from "@progress/kendo-react-grid";

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Window } from "@progress/kendo-react-dialogs";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import * as TmsService from "../common/restService/tmServices";
import "../IntelShipmentRequest/intelShip.css";
import { process } from "@progress/kendo-data-query";
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import "../commonStyle/tmsStyle.scss";
//import dm from '../IntelShipmentRequest/demo.jsx';
import { filterBy } from "@progress/kendo-data-query";
import $, { event } from "jquery";
import { filter } from "@progress/kendo-data-query/dist/npm/transducers";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import del from "../images/delete.png";
import edit from "../images/edit.png";
const dataState = {
  sort: [],
  take: 5,
  skip: 0,
};

class DetailComponent extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {
      deleteDigalog: false,
      UpdateItemID: null,
      buttname: "Create",
      disabledcurrency: false,
      childPackageform: false,
      currencyValue: "USD",
      materialValue: [],
      materialDesc: [],
      materialId: [],
      detailData: this.props.detailData,
      tor_id: sessionStorage.getItem("tor_id"),
      p_delete: false,
      p_edit: false,
    };
  }

  componentDidMount() {
    //alert(1)

    this.setState({ blocking: true });

    console.log("create_request", this.props.editEnable);

    this.state.ChildGridList = this.props.detailData;
    //Anitha's change
    var tor_id = sessionStorage.getItem("tor_id");
   // alert(tor_id)
    tor_id = tor_id.replaceAll(" ", "");
    if (tor_id.length > 10)
      this.state.tor_id = sessionStorage.getItem("tor_id").substr(10, 10);
    else this.state.tor_id = tor_id;
    this.setState({ disabledcurrency: true });
    this.state.StatusCodeValue = sessionStorage.getItem("DOCSTATUS");
    this.state.RequestType = sessionStorage.getItem("RequestMethodType");

    var editvalue = sessionStorage.getItem("IseditClicked");
console.log(this.state.StatusCodeValue)
    if (editvalue == "true") {
      if (this.state.StatusCodeValue == "10") {
        $("button.pd-btn").removeClass("menu-disable");
        this.setState({ p_edit: false, p_delete: false });
      } else {
        $("button.pd-btn").addClass("menu-disable");
        this.setState({ p_edit: true, p_delete: true });
      }
    } else {
      if (this.state.RequestType == "false") {
        if (this.state.StatusCodeValue != "") {
          this.setState({ p_edit: true, p_delete: true });
          $("button.pd-btn").addClass("menu-disable");
        } else {
          this.setState({ p_edit: true, p_delete: true });
          $("button.pd-btn").addClass("menu-disable");
        }
      }
      if (this.state.RequestType == "true") {
        if (this.state.StatusCodeValue == "10") {
          this.setState({ p_edit: false, p_delete: false });
          $("button.pd-btn").removeClass("menu-disable");
        } else {
          this.setState({ p_edit: false, p_delete: false });
          $("button.pd-btn").removeClass("menu-disable");
        }
      }
    }
    if (this.state.StatusCodeValue == "10") {
      $("button.pd-btn").removeClass("menu-disable");
    }
    this.setState({ blocking: false });
  }

  enableProduct() {
    $("button.pd-btn").removeClass("menu-disable");
  }

  BindChildGridData(Itms) {
    var childDataFiltered = [];
    var dbkeyValue = sessionStorage.getItem("dbKey");
    for (var i = 0; i < Itms.length; i++) {
      if (Itms[i].ITEM_PARENT_KEY == dbkeyValue) {
        var tempJson = Itms[i];
        childDataFiltered.push(tempJson);
      }
    }

    this.setState({ detailData: childDataFiltered });

    if (this.props.editEnable == true) {
      if (this.state.StatusCodeValue == "10") {
        $("button.pd-btn").removeClass("menu-disable");
        this.setState({ p_edit: false, p_delete: false });
      } else {
        $("button.pd-btn").addClass("menu-disable");
        this.setState({ p_edit: true, p_delete: true });
      }
    } else {
      if (this.state.RequestType == "false") {
        if (this.state.StatusCodeValue != "") {
          this.setState({ p_edit: true, p_delete: true });
          $("button.pd-btn").addClass("menu-disable");
        } else {
          this.setState({ p_edit: true, p_delete: true });
          $("button.pd-btn").addClass("menu-disable");
        }
      }
      if (this.state.RequestType == "true") {
        if (this.state.StatusCodeValue == "10") {
          this.setState({ p_edit: false, p_delete: false });
          $("button.pd-btn").removeClass("menu-disable");
        } else {
          this.setState({ p_edit: false, p_delete: false });
          $("button.pd-btn").removeClass("menu-disable");
        }
      }
    }

    this.setState({ blocking: false });
  }

  childPackage() {
    var vals = this.state.detailData.ITEM_ID;
    console.log("vals", vals);
    this.setState({
      childPackageform: true,
      baseState: this.state,
      buttname: "Create",
    });
    $("#childPackages").show();
  }

  async ChildProductCreate() {
    var Itm_ID = sessionStorage.getItem("ItmID");

    if (this.state.buttname == "Create") {
      $("button.pd-btn").addClass("menu-disable");
      var createInputs = {
        tor_id: this.state.tor_id,
        im_item: {
          item_descr: this.state.materialDesc,
          QUA_PCS_VAL: "",
          QUA_PCS_UNI: "",
          gro_wei_val: "",
          gro_wei_uni: "",
          length: "",
          width: "",
          height: "",
          measuom: "",
          package_tco: "",
          AMT_GDSV_VAL: this.state.materialValue,
          AMT_GDSV_CUR: "USD",
          product_id: this.state.materialId,
        },
        im_package_item_id: Itm_ID,
      };

      const result = await TmsService.CreateProductItem(
        createInputs,
        this.state.tor_type
      );
      console.log("Create PRod", result.ITEM_ID);

      if (result.STATUS == "SUCCESS") {
        $("button.pd-btn").removeClass("menu-disable");
        var ProductUpdate = {
          tor_id: this.state.tor_id,
          im_item: {
            item_descr: this.state.materialDesc,
            QUA_PCS_VAL: "",
            QUA_PCS_UNI: "",
            gro_wei_val: "",
            gro_wei_uni: "",
            length: "",
            width: "",
            height: "",
            measuom: "",
            package_tco: "",
            AMT_GDSV_VAL: this.state.materialValue,
            AMT_GDSV_CUR: "USD",
            product_id: this.state.materialId,
          },

          im_item_id: result.ITEM_ID,
        };

        this.ProductUpdateForm(ProductUpdate);
        this.setState({ blocking: true });
      }
      else
      {
        toast.error(result.STATUS,{theme:"colored"});

      }
    } else {
      var ProductUpdate = {
        tor_id: this.state.tor_id,
        im_item: {
          item_descr: this.state.materialDesc,
          QUA_PCS_VAL: "",
          QUA_PCS_UNI: "",
          gro_wei_val: "",
          gro_wei_uni: "",
          length: "",
          width: "",
          height: "",
          measuom: "",
          package_tco: "",
          AMT_GDSV_VAL: this.state.materialValue,
          AMT_GDSV_CUR: "USD",
          product_id: this.state.materialId,
        },

        im_item_id: this.state.UpdateItemID,
      };

      this.ProductUpdateForm(ProductUpdate);
      this.setState({ blocking: true });
      // if(getstsuts.Promise)
      //  setTimeout(()=>{toast.success("Product Updated Successfully")},5000);
    }
  }

  ProductUpdate = (data, event) => {
    if (this.state.p_edit == true) {
      return;
    }

    this.setState({ childPackageform: true, buttname: "Update" });
    var ProductItem = data.dataItem;
    this.setState({ UpdateItemID: ProductItem.ITEM_ID });
    this.state.materialId = ProductItem.PRODUCT_ID;
    this.state.materialDesc = ProductItem.ITEM_DESCR;
    this.state.materialValue = ProductItem.AMT_GDSV_VAL;
  };

  deletepopup(data) {
    var Delete_Itm_ID = data.dataItem.ITEM_ID;
    this.setState({ deleteDigalog: true, dle_tm: Delete_Itm_ID });
  }

  // ProductUpdate ProductDelete
  async ProductDelete() {
    this.setState({ blocking: true, deleteDigalog: false });
    var Itm_ID = this.state.dle_tm;
    var delete_item = { tor_id: this.state.tor_id, im_item_id: Itm_ID };
    const result = await TmsService.ProductDeleteItemCall(delete_item);
    if (result.STATUS == "SUCCESS") {
      //this.setState({deleteDigalog:false});
      var inputdatas = { tor_id: this.state.tor_id };
      const result = await TmsService.PackageDisplay(
        inputdatas,
        this.state.tor_type
      );
      if (result.STATUS == "SUCCESS") {
        toast.success("Data deleted successfully",{theme:"colored"});
        var IM_ITEM = result.EX_ITEM;
        this.BindChildGridData(IM_ITEM);
      }
    }
    this.setState({ blocking: false });
  }

  async ProductUpdateForm(ProductUpdate) {
    this.setState({ blocking: true });
    const result = await TmsService.PackageUpdateItem(
      ProductUpdate,
      this.state.tor_type
    );
    console.log("result", result);

    if ((result.STATUS = "SUCCESS")) {
      this.setState({ childPackageform: false });
      var inputdatas = { tor_id: this.state.tor_id };
      const result = await TmsService.PackageDisplay(
        inputdatas,
        this.state.tor_type
      );
      toast.success("Product saved Successfully",{theme:"colored"});

      if (result.STATUS == "SUCCESS") {
        var Itms = result.EX_ITEM;
        this.BindChildGridData(Itms);
      }
      this.setState({ blocking: false });
      this.setState({ materialDesc: "", materialValue: "", materialId: "" });
    }
  }

  childclosebtn = () => {
    //this.setState(this.baseState);
    $("#childPackages").hide();
    this.setState({ childPackageform: false });
    this.state.currencyValue = "USD";
    this.state.materialValue = "";
    this.state.materialDesc = "";
    this.state.materialId = "";
  };

  materialIdChanged = (event) => {
    this.setState({ materialId: event.target.value });
  };
  materialDescChanged = (event) => {
    this.setState({ materialDesc: event.target.value });
  };
  materialValueChanged = (event) => {
    this.setState({ materialValue: event.target.value });
  };
  materialcurrencyChanged = (e) => {
    this.setState({ currencyValue: e.target.value });
  };

  cancelpopup() {
    this.setState({ deleteDigalog: false });
  }
  render() {
    const childgrid = (
      <Grid
        ScrollMode="scrollable"
        width="100%"
        data={this.state.detailData}
        {...this.state.dataState}
        onDataStateChange={(e) => {
          this.setState({ dataState: e.dataState });
        }}
        dataGrid="myGrid"
        dataBound={this.onDataBound}
        pageable={true}
        reorderable
        ref={(childgrid) => {
          this._childgrid = childgrid;
        }}
      >
        <GridToolbar>
          <button
            className="btn k-button k-button-icontext pd-btn"
            onClick={this.childPackage.bind(this)}
          >Product</button>
        </GridToolbar>
        <GridColumn
          field=""
          title=""
          width="80px"
          filterable={false}
          cell={(props) => (
            <td>
              {!this.state.p_delete && (
                <img
                  src={del}
                  alt="delete"
                  onClick={this.deletepopup.bind(this, props)}
                  className="deimg"
                ></img>
              )}
            </td>
          )}
        ></GridColumn>

        <GridColumn
          field=""
          title=""
          width="80px"
          filterable={false}
          cell={(props) => (
            <td>
              {!this.state.p_edit && (
                <img
                  src={edit}
                  alt="Edit"
                  className="deimg"
                  onClick={this.ProductUpdate.bind(this, props)}
                ></img>
              )}
            </td>
          )}
        ></GridColumn>

        <GridColumn
          field=""
          filterable={false}
          headerCell={() => (
            <span>
              Handling Unit <em>*</em>
            </span>
          )}
          width="150px"
          filter="text"
        />
        <GridColumn
          field="PRODUCT_ID"
          title="Material ID"
          filter="text"
          width="130px"
          filterable={false}
        />
        <GridColumn
          field="ITEM_DESCR"
          title="Material Description"
          filter="text"
          width="130px"
          filterable={false}
        />
        <GridColumn
          field="AMT_GDSV_VAL"
          title="Material Value"
          filter="text"
          width="130px"
          filterable={false}
        />
        <GridColumn
          field="AMT_GDSV_CUR"
          title="Currency"
          filter="text"
          width="130px"
          filterable={false}
        />
        <GridColumn
          field="QUA_PCS_VAL"
          filterable={false}
          headerCell={() => (
            <span>
              Quantity <em>*</em>
            </span>
          )}
          filter="text"
          width="150px"
        />
        <GridColumn
          field="GRO_WEI_VAL"
          filterable={false}
          headerCell={() => (
            <span>
              Total Estimated Gross Weight <em>*</em>
            </span>
          )}
          filter="text"
          width="150px"
        />
        <GridColumn
          field="GRO_WEI_UNI"
          filterable={false}
          headerCell={() => (
            <span>
              Unit Of Measure Weight <em>*</em>
            </span>
          )}
          filter="text"
          width="150px"
        />
        <GridColumn
          field=""
          title="Dimensional Weight"
          filter="text"
          width="130px"
          filterable={false}
        />
        <GridColumn
          field="GRO_WEI_VAL"
          title="Chargable Weight"
          filter="text"
          width="130px"
          filterable={false}
        />
      </Grid>
    );

    return (
      <div>
      <BlockUi tag="div" blocking={this.state.blocking}
        
        loader={<Loaders />}>
          {this.state.deleteDigalog && (
            <Dialog
              title={"Confirmation Required"}
              onClose={this.cancelpopup.bind(this)}
            >
              <p style={{ margin: "25px", textAlign: "center" }}>
                Are you sure want to Delete?
              </p>
              <DialogActionsBar>
                <button
                  className="btn k-button k-button-icontext rejectbtn"
                  onClick={this.cancelpopup.bind(this)}
                >
                  Cancel
                </button>
                <button
                  className="btn k-button k-button-icontext"
                  onClick={this.ProductDelete.bind(this)}
                >
                  Confirm
                </button>
              </DialogActionsBar>
            </Dialog>
          )}

          <div className="col-md-12">
            <div id="childProduct">{childgrid}</div>

            {this.state.childPackageform && (
              <Dialog title={"Add/Edit Package"} onClose={this.childclosebtn.bind(this)}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Material ID
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              value={this.state.materialId}
                              onChange={this.materialIdChanged}
                              className="form-control"
                            ></input>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Material Description
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              value={this.state.materialDesc}
                              onChange={this.materialDescChanged}
                              className="form-control"
                            ></input>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Material Value
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              value={this.state.materialValue}
                              onChange={this.materialValueChanged}
                              className="form-control"
                            ></input>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Currency
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="text"
                              disabled={this.state.disabledcurrency}
                              value={this.state.currencyValue}
                              onChange={this.materialcurrencyChanged}
                              className="form-control"
                            ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                 <DialogActionsBar>
                    <button
                      type="button"
                      className="btn k-button k-button-icontext"
                      onClick={this.ChildProductCreate.bind(this)}
                    >
                      {this.state.buttname}
                    </button>

                    <button
                      type="button"
                      className="btn k-button k-button-icontext rejectbtn"
                      onClick={this.childclosebtn.bind(this)}
                    >
                      Cancel
                    </button>
                    </DialogActionsBar>
        </Dialog> 
            )}
          </div>
        </BlockUi>
      </div>
    );
  }
}

class ItemDetail extends React.Component {
  constructor() {
    super();

    this.unitem = { text: "Select unit of measure" };
    this.unwei = { text: "Select unit of measure" };
    this.handitem = { text: "Select handling unit" };

    this.state = {
      itemdetailData: [],
      dialogvisible: false,
      totalChargWeight: [],
      buttname: "Create",
      //prod_disable:false,
      edit: false,
      delete: false,
      dataState: dataState,
      itemdetailShow: false,
      filterHand: [],
      handlingUnitValue: { text: "Select Handling Unit", value: null },
      unitMeasureValue: { text: "Select unit of measure", value: null },
      LHWunitMeasurevalue: { text: "Select unit of measure", value: null },
      HandlingData: [],
      GridPackageData: [],
      unitMeasureData: [],
      LHWmeasureData: [],
      Grossweightvalue: "",
      PackLengthValue: "",
      PackHeightValue: "",
      PackageWidthValue: "",
      ChildItem: [],
      deletedisabled: false,
      UnitMesDisabled: false,
      tor_id: sessionStorage.getItem("tor_id"),
      DocStatusCode: "",
      tor_type: "",
      //  isEditClicked:this.props.props.isEditClicked
    };

    this.baseState = this.state;
    this.ITEMCREATEUPDATE = this.ITEMCREATEUPDATE.bind(this);
    this.DetailCompRef = React.createRef(null);;
  }

  async componentDidMount() {
    //var dd=sessionStorage.getItem("IseditClicked");
    //console.log("dd",dd);
    console.log("Order Type value", this.props);
    this.state.tor_type = this.props.props.tor_Type;

    this.setState({ blocking: true });
    this.handlingGetData();
    //this.measureData();
    this.LHWmeasureDataList();
    var DocStatusCode = sessionStorage.getItem("DOCSTATUS");
    this.setState({ ItemstatusCode: DocStatusCode });
    this.state.tor_id = sessionStorage.getItem("tor_id");
    var tor_d = sessionStorage.getItem("tor_id");
    tor_d = tor_d.replaceAll(" ", "");

    if (tor_d.length > 10) {
      var inputdatas = { tor_id: this.state.tor_id.substr(10, 10) };
    } else var inputdatas = { tor_id: this.state.tor_id };
    const result = await TmsService.PackageDisplay(
      inputdatas,
      this.state.tor_type
    );
 
    var IM_ITEM = result.EX_ITEM;
    this.Display_ItemDetail(IM_ITEM);

    if (this.props.props.isEditClicked == true) {
      if (this.state.ItemstatusCode == "10") {
        $("button.packageCreateButton").removeClass("menu-disable");
        this.setState({ delete: false, edit: false });
      } else {
        $("button.packageCreateButton").addClass("menu-disable");
        this.setState({ delete: true, edit: true });
      }
    } else {
      if (this.props.props.create_request == false) {
        if (this.state.ItemstatusCode !== "") {
          $("button.packageCreateButton").addClass("menu-disable");
          this.setState({ delete: true, edit: true });
        }
      } else if (this.props.props.create_request == true) {
        if (this.state.ItemstatusCode == "10") {
          $("button.packageCreateButton").removeClass("menu-disable");
          this.setState({ delete: false, edit: false });
        }
      }
    }

    // if(DocStatusCode == "10")
    // {
    //   $("button.packageCreateButton").removeClass("menu-disable");
    // }
    // else
    // {
    //   $("button.packageCreateButton").addClass("menu-disable");
    // }

    this.setState({ blocking: false });
  }

  onFoCopyResetPage() {
    
    this.setState({ blocking: true });
    // constructor

    this.unitem = { text: "Select unit of measure" };
    this.unwei = { text: "Select unit of measure" };
    this.handitem = { text: "Select handling unit" };

    this.setState({
      itemdetailData: [],
      dialogvisible: false,
      totalChargWeight: [],
      buttname: "Create",
      //prod_disable:false,
      edit: false,
      delete: false,
      dataState: dataState,
      itemdetailShow: false,
      filterHand: [],
      handlingUnitValue: { text: "Select Handling Unit", value: null },
      unitMeasureValue: { text: "Select unit of measure", value: null },
      LHWunitMeasurevalue: { text: "Select unit of measure", value: null },
      HandlingData: [],
      GridPackageData: [],
      unitMeasureData: [],
      LHWmeasureData: [],
      Grossweightvalue: "",
      PackLengthValue: "",
      PackHeightValue: "",
      PackageWidthValue: "",
      ChildItem: [],
      deletedisabled: false,
      UnitMesDisabled: false,
      tor_id: sessionStorage.getItem("tor_id"),
      DocStatusCode: "",
      tor_type: "",
      //  isEditClicked:this.props.props.isEditClicked
    });

    this.baseState = this.state;
    this.ITEMCREATEUPDATE = this.ITEMCREATEUPDATE.bind(this);

    // extra operations form companent did mount
    this.handlingGetData();
    this.LHWmeasureDataList();
    this.measureData();

    $("button.packageCreateButton").removeClass("menu-disable");
    this.setState({ blocking: false });
  }

  productRefresh() {
    if (this.DetailCompRef.current === null) return;
    if (this.DetailCompRef.current.enableProduct() !== null) {
      this.DetailCompRef.current.enableProduct()
    }
  }

  MyDetailComponent = (props) => {
    console.log(this.props);

    return (
      <DetailComponent
        {...props}
        data={this.props.data}
        DocStatusCode={this.state.DocStatusCode}
        editEnable={this.props.props.isEditClicked}
        detailData={this.state.detailData}
        ref={this.DetailCompRef}
      />
    );
  };

  componentDidUpdate() {
    this.state.editclick = this.props.props.isEditClicked;
  }

  Display_ItemDetail(IM_ITEM) {
    this.setState({ blocking: true });
    var parentGridArr = [];
    var childGridArr = [];
    var totalChargableWeight = 0;
    this.state.unitOfMeasureWeight = "";

    if (typeof IM_ITEM !== "undefined" && IM_ITEM != null) {
      for (var i = 0; i < IM_ITEM.length; i++) {
        if (
          IM_ITEM[i].PACKAGE_TCO !== undefined &&
          IM_ITEM[i].PACKAGE_TCO != ""
        ) {
          IM_ITEM[i]["DIM_WEI_VAL"] = IM_ITEM[i].DIM_WEI_VAL;
          IM_ITEM[i]["CHR_WEI_VAL"] =
            IM_ITEM[i].DIM_WEI_VAL > IM_ITEM[i].GRO_WEI_VAL
              ? IM_ITEM[i].DIM_WEI_VAL
              : IM_ITEM[i].GRO_WEI_VAL;
          //IM_ITEM[i]["CHR_WEI_VAL"]=(chargewgt;
          totalChargableWeight += IM_ITEM[i]["CHR_WEI_VAL"];
          parentGridArr.push(IM_ITEM[i]);
          this.state.unitOfMeasureWeight = IM_ITEM[i]["GRO_WEI_UNI"];
          console.log("unitOfMeasureWeight", this.state.unitOfMeasureWeight);
          var unitOfMeasureLWH = IM_ITEM[i]["MEASUOM"];
        } else {
          childGridArr.push(IM_ITEM[i]);
        }

        this.state.GridPackageData = parentGridArr;
        this.setState({
          itemdetailShow: false,
          ChildItem: parentGridArr,
          totalChargWeight: totalChargableWeight.toFixed(2),
        });
      }
    }

    if (this.props.props.isEditClicked == true) {
      if (this.state.ItemstatusCode == "10") {
        $("button.packageCreateButton").removeClass("menu-disable");
        this.setState({ delete: false, edit: false });
      } else {
        $("button.packageCreateButton").addClass("menu-disable");
        this.setState({ delete: true, edit: true });
      }
    } else {
      if (this.props.props.create_request == false) {
        if (this.state.ItemstatusCode !== "") {
          $("button.packageCreateButton").addClass("menu-disable");
          this.setState({ delete: true, edit: true });
        }
      } else if (this.props.props.create_request == true) {
        if (this.state.ItemstatusCode == "10") {
          $("button.packageCreateButton").removeClass("menu-disable");
          this.setState({ delete: false, edit: false });
        }
      }
    }
    this.setState({ blocking: false });
  }

  validation() {
    if (
      this.state.handlingUnitValue.value == null ||
      this.state.handlingUnitValue.value == "" ||
      this.state.handlingUnitValue.value == "undefined"
    ) {
      toast.error("Please select Handling Unit", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        
      });
      return;
    }

    if (
      this.state.quantityValue == null ||
      this.state.quantityValue == "" ||
      this.state.quantityValue == "undefined"
    ) {
      toast.error("Please enter Quantity", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"       
      });
      return;
    }

    if (
      this.state.Grossweightvalue == null ||
      this.state.Grossweightvalue == "0" ||
      this.state.Grossweightvalue == "undefined"
    ) {
      toast.error("Please enter Estimated Gross Weight", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"       
      });
      return;
    }

    if (
      this.state.unitMeasureValue.value == null ||
      this.state.unitMeasureValue.value == "" ||
      this.state.unitMeasureValue.value == "undefined"
    ) {
      toast.error("Please select Unit of Measure Weight", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        
      });
      return;
    }

    if (this.state.PackHeightValue > 99999999.99) {
      toast.error("Height cannot be greater than 99999999.99", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        
      });
      return;
    }
    if (this.state.PackLengthValue > 99999999.99) {
      toast.error("Length cannot be greater than 99999999.99", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      
      });
      return;
    }
    if (this.state.PackageWidthValue > 99999999.99) {
      toast.error("Width cannot be greater than 99999999.99", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"       
      });
      return;
    }

    return "success";
  }

  deleterow = (data, event) => {
    // if(this.state.delete==true){
    //    return;
    // }

    this.setState({ dialogvisible: true });
    console.log(data.dataItem.ITEM_ID);
    this.setState({ deleteCode: data.dataItem.ITEM_ID });
  };

  async confirmDelete() {
    this.setState({ dialogvisible: false, blocking: true });
    //console.log("eventtttt",this.props.data);
    var Item_ID = {
      tor_id: this.state.tor_id,
      im_item_id: this.state.deleteCode,
    };
    const result = await TmsService.ProductDeleteItemCall(Item_ID);

    if ((result.STATUS = "SUCCESS")) {
      var inputdatas = { tor_id: this.state.tor_id };
      const result = await TmsService.PackageDisplay(
        inputdatas,
        this.state.tor_type
      );
      if (result.STATUS == "SUCCESS") {
        toast.success("Data deleted successfully");
        var IM_ITEM = result.EX_ITEM;
        this.Display_ItemDetail(IM_ITEM);
        this.setState({ blocking: false });
      }
    }
  }

  Edit = (data, event) => {
    //   if(this.state.edit==true){
    //     return;
    //  }

    var EditRow = data.dataItem;
    console.log("EditRow", EditRow);
    this.state.Item_ID = EditRow.ITEM_ID;
    this.state.AMT_GDSV_CUR = EditRow.AMT_GDSV_CUR;
    this.state.AMT_GDSV_VAL = EditRow.AMT_GDSV_VAL;
    var itemHandlingUnit = this.getHandlingUnit(EditRow.PACKAGE_TCO);
    var measureUnits = this.getMeasureUnits(EditRow.GRO_WEI_UNI);
    var getLHWs = this.getLHW(EditRow.MEASUOM);
    this.setState({
      handlingUnitValue: { value: EditRow.PACKAGE_TCO, text: itemHandlingUnit },
      quantityValue: EditRow.QUA_PCS_VAL,
      Grossweightvalue: EditRow.GRO_WEI_VAL,
      PackHeightValue: EditRow.HEIGHT,
      unitMeasureValue: { value: EditRow.GRO_WEI_UNI, text: measureUnits },
      PackLengthValue: EditRow.LENGTH,
      PackageWidthValue: EditRow.WIDTH,
      LHWunitMeasurevalue: { value: EditRow.MEASUOM, text: getLHWs },
    });
    this.setState({ itemdetailShow: true, buttname: "Update" });
  };

  async FO_Activity_Update(inputdata) {
    this.setState({ blocking: true });

    const result = await TmsService.PackageUpdateItem(inputdata);
    console.log("result", result);

    if (result.STATUS == "SUCCESS") {
      $("#ItemModal").hide();

      var inputdatas = { tor_id: this.state.tor_id };

      const result = await TmsService.PackageDisplay(
        inputdatas,
        this.state.tor_type
      );
      console.log(" FO result=>", result);
      //var itemPackage=result[]
      if (result != undefined) {
        var ITEM = result.EX_ITEM;
        this.Display_ItemDetail(ITEM);

        this.setState({ blocking: false });
        this.setState({
          handlingUnitValue: { text: "Select Handling Unit", value: null },
          unitMeasureValue: { text: "Select unit of measure", value: null },
          LHWunitMeasurevalue: { text: "Select unit of measure", value: null },
          Grossweightvalue: "",
          PackLengthValue: "",
          PackHeightValue: "",
          PackageWidthValue: "",
          quantityValue: "",
        });
      }
    }
  }

  async ITEMCREATEUPDATE() {
    // this.setState({blocking:true});

    if (this.validation() == "success") {
      if (this.state.buttname == "Create") {
        $("button.packageCreateButton").addClass("menu-disable");

        var Create_input = {
          tor_id: this.state.tor_id,
          im_item: {
            item_descr: "",
            QUA_PCS_VAL: this.state.quantityValue,
            QUA_PCS_UNI: "EA",
            gro_wei_val: Number(this.state.Grossweightvalue),
            gro_wei_uni: this.state.unitMeasureValue.value,
            length: Number(this.state.PackLengthValue),
            width: Number(this.state.PackageWidthValue),
            height: Number(this.state.PackHeightValue),
            measuom: this.state.LHWunitMeasurevalue.value,
            package_tco: this.state.handlingUnitValue.value,
            AMT_GDSV_VAL: "",
            AMT_GDSV_CUR: "USD",
            product_id: "",
          },
          im_item_id: "",
        };

        const result = await TmsService.CreateItemPackage(
          Create_input,
          this.state.tor_type
        );
        // console.log("result",result);

        if ((result.STATUS = "SUCCESS")) {
          this.setState({ itemdetailShow: false },() => { toast.success("Package Create Successfully") });

          this.setState({ childPackageform: false });

          $("button.packageCreateButton").removeClass("menu-disable");

          var Create_update = {
            tor_id: this.state.tor_id,
            im_item: {
              item_descr: "",
              QUA_PCS_VAL: this.state.quantityValue,
              QUA_PCS_UNI: "EA",
              gro_wei_val: Number(this.state.Grossweightvalue),
              gro_wei_uni: this.state.unitMeasureValue.value,
              length: Number(this.state.PackLengthValue),
              width: Number(this.state.PackageWidthValue),
              height: Number(this.state.PackHeightValue),
              measuom: this.state.LHWunitMeasurevalue.value,
              package_tco: this.state.handlingUnitValue.value,
              AMT_GDSV_VAL: "",
              AMT_GDSV_CUR: "USD",
              product_id: "",
            },
            im_item_id: result.ITEM_ID,
          };

          this.FO_Activity_Update(Create_update);
        }

        return true;
      } else {
        var QUA_PCS_VAL = String(this.state.quantityValue);
        var gro_wei_val = Number(this.state.Grossweightvalue);
        var length = Number(this.state.PackLengthValue);
        var width = Number(this.state.PackageWidthValue);
        var height = Number(this.state.PackHeightValue);

        var inputdata = {
          tor_id: this.state.tor_id,
          im_item: {
            QUA_PCS_VAL: QUA_PCS_VAL,
            QUA_PCS_UNI: "EA",
            gro_wei_val: gro_wei_val,
            gro_wei_uni: this.state.unitMeasureValue.value,
            length: length,
            width: width,
            height: height,
            measuom: this.state.LHWunitMeasurevalue.value,
            package_tco: this.state.handlingUnitValue.value,
            AMT_GDSV_VAL: this.state.AMT_GDSV_VAL,
            AMT_GDSV_CUR: this.state.AMT_GDSV_CUR,
          },

          im_item_id: this.state.Item_ID,
        };

        this.FO_Activity_Update(inputdata, "update");
        this.setState({ blocking: true });
        toast.success("Package Updated Successfully");
      }

      return true;
    }
  }

  async handlingGetData() {
    //F4_HANDLING_UNITS

    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_HANDLING_UNITS";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    console.log("result", result);
    this.setState({ HandlingData: result, filterHand: result });
  }

  async measureData() {
    //F4_WTS_UNITS_OF_MESAURE

    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_WTS_UNITS_OF_MESAURE";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    console.log("result", result);

    var unitmeasure = [];
    for (var i = 0; i < result.length; i++) {
      if (result[i].value) {
        var obj = {};
        obj.text = result[i].value + "-" + result[i].text;
        obj.value = result[i].value;
        unitmeasure.push(obj);
      }
    }

    this.setState({ unitMeasureData: unitmeasure });
  }

  async LHWmeasureDataList() {
    //F4_WTS_UNITS_OF_MESAURE

    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_UNITS_OF_MESAURE";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    console.log("result", result);
    var LHWmeasure = [];
    for (var i = 0; i < result.length; i++) {
      if (result[i].value) {
        var obj = {};
        obj.text = result[i].value + "-" + result[i].text;
        obj.value = result[i].value;
        LHWmeasure.push(obj);
      }
    }
    this.setState({ LHWmeasureData: LHWmeasure });
  }

  CreateItem() {
    //this.setState({ unitMeasureData: unitmeasure });

    if (this.state.GridPackageData.length >= 1) {
      this.setState({ unitMeasureData: [] });

      var kg, lb;

      this.state.GridPackageData.filter(function (ele, pos) {
        if (ele.GRO_WEI_UNI == "KG") kg = ele.GRO_WEI_UNI;
        else if (ele.GRO_WEI_UNI == "LB") lb = ele.GRO_WEI_UNI;
      });

      if (kg == "KG") {
        this.setState({
          unitMeasureValue: { text: "KG-KILOGRAM", value: "KG" },
        });
      } else if (lb == "LB") {
        this.setState({
          unitMeasureValue: { text: "LB-US POUND", value: "LB" },
        });
      }
    } else {
      this.measureData();
    }
this.state.itemdetailShow=true;
    this.setState({ baseState: this.state });
    this.setState({ itemdetailShow: true, buttname: "Create" });
  }

  getServiceDesc(dd) {
    var description = "";
    for (var i = 0; i < this.state.BindReasonCode.length; i++) {
      if (this.state.BindReasonCode[i].value == dd) {
        var descParts =
          this.state.BindReasonCode[i].value +
          " - " +
          this.state.BindReasonCode[i].text;
        description = descParts;
      }
    }
    return description;
  }

  getHandlingUnit(values) {
    var hvalue = [];

    for (var i = 0; i < this.state.HandlingData.length; i++) {
      if (this.state.HandlingData[i].value == values) {
        var hvalue = this.state.HandlingData[i].text;
      }
    }
    return hvalue;
  }

  getMeasureUnits(values) {
    var hvalue = [];
    for (var i = 0; i < this.state.unitMeasureData.length; i++) {
      if (this.state.unitMeasureData[i].value == values) {
        var hvalue =
          this.state.unitMeasureData[i].value +
          "-" +
          this.state.unitMeasureData[i].text;
      }
    }
    return hvalue;
  }

  getLHW(values) {
    var hvalue = [];
    for (var i = 0; i < this.state.LHWmeasureData.length; i++) {
      if (this.state.LHWmeasureData[i].value == values) {
        var hvalue = this.state.LHWmeasureData[i].text;
      }
    }
    return hvalue;
  }

  closebtn = () => {
    // this.setState(this.baseState);
    this.setState({ itemdetailShow: false, baseState: this.state });

    this.setState({
      handlingUnitValue: { text: "Select Handling Unit", value: null },
      unitMeasureValue: { text: "Select unit of measure", value: null },
      LHWunitMeasurevalue: { text: "Select unit of measure", value: null },
      Grossweightvalue: "",
      PackLengthValue: "",
      PackHeightValue: "",
      PackageWidthValue: "",
      quantityValue: "",
    });
  };
  HandlingUnitChanged = (event) => {
    this.setState({ handlingUnitValue: event.target.value });
  };

  unitMeasureChanged = (event) => {
    this.setState({ unitMeasureValue: event.target.value });
  };

  LHWunitMeasureChanged = (event) => {
    this.setState({ LHWunitMeasurevalue: event.target.value });
  };

  PackageWidthChanged = (event) => {
    this.setState({ PackageWidthValue: event.target.value });
  };
  PackageLenChanged = (event) => {
    this.setState({ PackLengthValue: event.target.value });
  };
  PackHeightChanged = (event) => {
    this.setState({ PackHeightValue: event.target.value });
  };
  quantitychanged = (event) => {
    this.setState({ quantityValue: event.target.value });
  };
  GrossweightChanged = (event) => {
    this.setState({ Grossweightvalue: event.target.value });
  };

  handlingfilterchanged = (event) => {
    this.setState({
      HandlingData: this.filterfilterDatas(event.filter),
    });
  };

  filterfilterDatas(filter) {
    const data = this.state.filterHand.slice();
    return filterBy(data, filter);
  }

  expandChange = (event) => {
    event.dataItem.expanded = !event.dataItem.expanded;
    let categoryID = event.dataItem.PRODUCT_ID;
    this.state.dbkey = event.dataItem.DB_KEY;
    sessionStorage.setItem("ItmID", event.dataItem.ITEM_ID);
    sessionStorage.setItem("dbKey", event.dataItem.DB_KEY);
    var statusCodes = sessionStorage.getItem("DOCSTATUS");
    const Data = this.props.props.create_request;
    sessionStorage.setItem("RequestMethodType", Data);
    this.setState({ statusCode: statusCodes });
    // console.log("Data",Data);
    var childDataFiltered = [];
    //console.log("this.props.data",this.props.data);
    var details = this.props.data;
    for (var i = 0; i < this.props.data.length; i++) {
      if (this.props.data[i].ITEM_PARENT_KEY == this.state.dbkey) {
        var tempJson = this.props.data[i];
        childDataFiltered.push(tempJson);
      }
    }
    if (childDataFiltered.length == 0) {
      $("#childProduct").hide();
      this.setState({ detailData: childDataFiltered });
      this.forceUpdate();
    } else {
      $("#childProduct").show();
      this.setState({ detailData: childDataFiltered });
      this.forceUpdate();
    }
  };

  canceltm = () => {
    this.setState({ dialogvisible: false });
  };

  render() {
    const grid = (
      <Grid
        ScrollMode="scrollable"
        style={{ height: "600px", width: 'auto'}}
        pageable
        sortable
        data={process(this.state.ChildItem, this.state.dataState)}
        detail={this.MyDetailComponent}
        expandField="expanded"
        onExpandChange={this.expandChange}
        {...this.state.dataState}
        onDataStateChange={(e) => {
          this.setState({ dataState: e.dataState });
        }}
        filterable
        filter={this.state.filter}
        // onFilterChange={(e) => {
        //   this.setState({
        //     filter: e.filter,
        //   });
        // }}
        // dataGrid="myGrid"
        // dataBound={this.onDataBound}
        // pageable={true}
        // reorderable
        // ref={(grid) => {
        //   this._grid = grid;
        // }}
      >
        <GridToolbar>
          <button
            className="btn k-button k-button-icontext packageCreateButton"
            onClick={this.CreateItem.bind(this)}
          >
            Package
          </button>
        </GridToolbar>
        <GridColumn
          filterable={false}
          field=""
          title=""
          width="50px"
          cell={(props) => (
            <td>
              {!this.state.delete && (
                <div>
                  <img
                    onClick={this.deleterow.bind(this, props)}
                    src={del}
                    alt="delete"
                    className="pdeming"
                  ></img>
                </div>
              )}
            </td>
          )}
        ></GridColumn>

        <GridColumn
          filterable={false}
          field=""
          title=""
          width="50px"
          cell={(props) => (
            <td>
              {!this.state.edit && (
                <div>
                  <img
                    onClick={this.Edit.bind(this, props)}
                    src={edit}
                    alt="edit"
                    className="pdeming"
                  ></img>
                </div>
              )}
            </td>
          )}
        ></GridColumn>

        <GridColumn
          filterable={false}
          field="PACKAGEDESCRIPTION"
          headerCell={() => (
            <span>
              Handling Unit <em>*</em>
            </span>
          )}
          width="150px"
          filter="text"
        />
        <GridColumn
          filterable={false}
          field="PRODUCT_ID"
          title="Material ID"
          filter="text"
          width="150px"
        />
        <GridColumn
          filterable={false}
          field="ITEM_DESCR"
          title="Material Description"
          filter="text"
          width="150px"
        />
        <GridColumn
          filterable={false}
          field="MATERIAL_VALUE"
          title="Material Value"
          filter="text"
          width="150px"
        />
        <GridColumn
          field=""
          title="Currency"
          filter="text"
          width="150px"
          filterable={false}
        />
        <GridColumn
          filterable={false}
          field="QUA_PCS_VAL"
          headerCell={() => (
            <span>
              Quantity <em>*</em>
            </span>
          )}
          filter="text"
          width="150px"
        />
        <GridColumn
          filterable={false}
          field="GRO_WEI_VAL"
          headerCell={() => (
            <span>
              Total Estimated Gross Weight <em>*</em>
            </span>
          )}
          filter="text"
          width="150px"
        />
        <GridColumn
          filterable={false}
          field="GRO_WEI_UNI"
          headerCell={() => (
            <span>
              Unit Of Measure Weight <em>*</em>
            </span>
          )}
          filter="text"
          width="150px"
        />
        <GridColumn
          filterable={false}
          field="DIM_WEI_VAL"
          title="Dimensional Weight"
          filter="text"
          width="130px"
        />
        <GridColumn
          filterable={false}
          field="CHR_WEI_VAL"
          title="Chargable Weight"
          filter="text"
          width="130px"
        />
        <GridColumn
          field="LENGTH"
          title="Length"
          filter="text"
          width="120px"
          filterable={false}
        />
        <GridColumn
          field="WIDTH"
          title="Width"
          filter="text"
          width="120px"
          filterable={false}
        />
        <GridColumn
          field="HEIGHT"
          title="Height"
          filter="text"
          width="120px"
          filterable={false}
        />
        <GridColumn
          filterable={false}
          field="MEASUOM"
          title="Unit Of Measure(L,W,H)"
          filter="text"
          width="150px"
        />
        {/* <GridColumn field="" title="Unit Of Measure(L,H,W)" filter="text" width="150px"/> */}
      </Grid>
    );

    return (
      <div>
         <BlockUi tag="div" blocking={this.state.blocking}
        
        loader={<Loaders />}>
          {/* <ToastContainer
            id="toastitem"
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <ToastContainer /> */}

          {this.state.dialogvisible && (
            <Dialog
              title={"Confirmation Required"}
              onClose={this.canceltm.bind(this)}
            >
              <p style={{ margin: "25px", textAlign: "center" }}>
                Are you sure want to Delete?
              </p>
              <DialogActionsBar>
                <button
                  className="btn k-button k-button-icontext rejectbtn"
                  onClick={this.canceltm.bind(this)}
                >
                  Cancel
                </button>
                <button
                  className="btn k-button k-button-icontext"
                  onClick={this.confirmDelete.bind(this)}
                >
                  Confirm
                </button>
              </DialogActionsBar>
            </Dialog>
          )}

          <div className="content-fuild">
            <div className="row">
              <div className="col-md-12">
                <div id="itemdiv">
                  <div>{grid}</div>
                  <p className="tchw">
                    Total Chargeable Weight : {this.state.totalChargWeight}{" "}
                    {this.state.unitOfMeasureWeight}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
          {this.state.itemdetailShow && (
        <Dialog title={"Add/Edit Package"} onClose={this.closebtn}>
          <div className="row">
                      <div className="col-md-12">
                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Handling Unit <em>*</em>
                          </label>
                          <div className="col-sm-5">
                            <DropDownList
                              value={this.state.handlingUnitValue}
                              data={this.state.HandlingData}
                              filterable={true}
                              style={{ width: "100%" }}
                              onChange={this.HandlingUnitChanged}
                              defaultItem={this.handitem}
                              onFilterChange={this.handlingfilterchanged}
                              dataItemKey="value"
                              textField="text"
                            ></DropDownList>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Quantity <em>*</em>
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.quantityValue}
                              onChange={this.quantitychanged}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Total Estimated Gross Weight <em>*</em>
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.Grossweightvalue}
                              onChange={this.GrossweightChanged}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Unit of Measure Weight <em>*</em>
                          </label>
                          <div className="col-sm-5">
                            <DropDownList
                              value={this.state.unitMeasureValue}
                              data={this.state.unitMeasureData}
                              style={{ width: "100%" }}
                              filterable={true}
                              onChange={this.unitMeasureChanged}
                              dataItemKey="value"
                              defaultItem={this.unwei}
                              disabled={this.state.UnitMesDisabled}
                              textField="text"
                            ></DropDownList>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Length{" "}
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.PackLengthValue}
                              onChange={this.PackageLenChanged}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Width{" "}
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.PackageWidthValue}
                              onChange={this.PackageWidthChanged}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Height{" "}
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.PackHeightValue}
                              onChange={this.PackHeightChanged}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label for="" className="col-sm-6 col-form-label">
                            Unit Of Measure(L,W,H)
                          </label>
                          <div className="col-sm-5">
                            <DropDownList
                              value={this.state.LHWunitMeasurevalue}
                              defaultItem={this.unitem}
                              style={{ width: "100%" }}
                              data={this.state.LHWmeasureData}
                              onChange={this.LHWunitMeasureChanged}
                              dataItemKey="value"
                              textField="text"
                            ></DropDownList>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
          <DialogActionsBar>
          <button
                      type="button"
                      className="btn k-button k-button-icontext"
                      onClick={this.ITEMCREATEUPDATE}
                    >
                      {this.state.buttname}
                    </button>

                    <button
                      type="button"
                      className="btn k-button k-button-icontext rejectbtn"
                      onClick={this.closebtn.bind(this)}
                    >
                      Cancel
                    </button>
          </DialogActionsBar>
        </Dialog>
      )}
          </div>
        </BlockUi>
      </div>
    );
  }
}
export default ItemDetail;